import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
//#region src/modules/ServicePeriods/instance/is-same-calendar-day.ts
dayjs.extend(utc);
dayjs.extend(timezone);
function toZoned(iso, timeZone) {
	return timeZone ? dayjs(iso).tz(timeZone) : dayjs(iso);
}
function isSameCalendarDay(startsAt, endsAt, timeZone) {
	return toZoned(startsAt, timeZone).format("YYYY-MM-DD") === toZoned(endsAt, timeZone).format("YYYY-MM-DD");
}
//#endregion
export { isSameCalendarDay };

//# sourceMappingURL=is-same-calendar-day.js.map